import { TokenLogos } from '../assets/tokenLogos';

// Network configuration
export const FANTOM_NETWORK = {
  chainId: '0xfa', // 250 in hex
  chainName: 'Fantom Opera',
  nativeCurrency: {
    name: 'FTM',
    symbol: 'FTM',
    decimals: 18,
  },
  rpcUrls: ['https://rpc.fantom.network'],
  blockExplorerUrls: ['https://ftmscan.com/'],
};

// Contract addresses - Keep same vault, add SwapperV2 for fee collection
export const CONTRACTS = {
  VAULT: process.env.REACT_APP_VAULT_ADDRESS || '0x4E8d6150c1C1f453cc41431231189b8BDe88740F',
  SWAPPER_V2: process.env.REACT_APP_SWAPPER_V2_ADDRESS || '0xE660BCc431087c3BFC84558426EA664bdD3A0124',
};

// Fee configuration
export const FEE_CONFIG = {
  FEE_PERCENTAGE: 100, // 1% = 100 basis points
  BASIS_POINTS: 10000,
};

// DEX Configurations
export const DEX_CONFIGS = {
  // Lif3 V3 (Uniswap V3 fork) - Disabled: causing errors and slowdowns
  LIF3_V3: {
    id: 'lif3_v3',
    name: 'Lif3 V3',
    type: 'v3',
    version: 3,
    factory: '0x5Af34712aE630b7754764a81D815A56963e6214a',
    quoter: '0x93C5d13D2D13A56b4055C6D6D2851d784e94E22B',
    router: '0xe46eAb896b120Ea257B7950e40e363ef9e7EE2B7',
    positionManager: '0xaF46F3b96ae15c96B76369e27d5380A844d4e407',
    descriptor: '0x95A4C0736CFC7030Da2170A68b5802BaCc061183',
    enabled: false,
  },
  
  // Spooky V3 - Disabled: causing errors and slowdowns
  SPOOKY_V3: {
    id: 'spooky_v3',
    name: 'SpookySwap V3',
    type: 'v3',
    version: 3,
    factory: '0x7928a2c48754501f3a8064765ECaE541daE5c3E6',
    quoter: '0xB9507f2ED171D52c5c2EFaeAbdE440d264504A92',
    router: '0x40F70B72796C30f355dF859B2c8F94f18c38AdF8',
    positionManager: '0xb39d21718e24DE36fDD8c5C73e928B5EFF33d6C2',
    tickLens: '0xbaA8353CC9d02733eF12f9556ed999521f6E554c',
    staker: '0x9c04f7a1506aBDDe1A3Bb8aB1a2Da520bDF79E68',
    permit2: '0x838c010F57889195C88f2097488e49B7ad04EcB1',
    enabled: false,
  },
  
  // Spooky V2
  SPOOKY_V2: {
    id: 'spooky_v2',
    name: 'SpookySwap V2',
    type: 'v2',
    version: 2,
    factory: '0x152eE697f2E276fA89E96742e9bB9aB1f2E61bE3',
    router: '0xF491e7B69E4244ad4002BC14e878a34207E38c29',
    enabled: true,
  },
  
  // WigoSwap V2
  WIGO_V2: {
    id: 'wigo_v2',
    name: 'WigoSwap V2',
    type: 'v2',
    version: 2,
    factory: '0xC831A5cBfb4aC2Da5ed5B194385DFD9bF5bFcBa7',
    router: '0x5023882f4D1EC10544FCB2066abE9C1645E95AA0',
    enabled: true,
  },
  
  // Lif3 V2 (Legacy - from V1)
  LIF3_V2: {
    id: 'lif3_v2',
    name: 'Lif3 V2',
    type: 'v2',
    version: 2,
    factory: '0xE236f6890F1824fa0a7ffc39b1597A5A6077Cfe9',
    router: '0x6D0176C5ea1e44b08D3dd001b0784cE42F47a3A7',
    enabled: true,
  },
};

// Get enabled DEXes
export const getEnabledDexes = () => {
  return Object.values(DEX_CONFIGS).filter(dex => dex.enabled);
};

// Get DEXes by type
export const getDexesByType = (type) => {
  return Object.values(DEX_CONFIGS).filter(dex => dex.type === type && dex.enabled);
};

// Token addresses and configurations
export const TOKENS = {
  FTM: {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'FTM',
    name: 'Fantom',
    decimals: 18,
    logo: TokenLogos.FTM,
    isNative: true,
    isWhitelisted: true,
  },
  WFTM: {
    address: '0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83',
    symbol: 'WFTM',
    name: 'Wrapped Fantom',
    decimals: 18,
    logo: TokenLogos.WFTM,
    isNative: false,
    isWhitelisted: true,
  },
  // New LIF3 token
  LIF3_NEW: {
    address: '0x5e074C28149cC35c1e5fbC79d8A6ea688dba2314',
    symbol: 'LIF3',
    name: 'Lif3',
    decimals: 18,
    logo: TokenLogos.LIF3_NEW,
    isNative: false,
    isWhitelisted: true,
    links: {
      ftmscan: 'https://ftmscan.com/address/0x5e074C28149cC35c1e5fbC79d8A6ea688dba2314',
      info: 'https://v3.info.lif3.com/#/fantom/tokens/0x5e074c28149cc35c1e5fbc79d8a6ea688dba2314',
    },
  },
  // New LSHARE token
  LSHARE_NEW: {
    address: '0x8fF27b58E1d969bEFC9c8aEAE93A6EB7E2250c8f',
    symbol: 'LSHARE',
    name: 'LShare',
    decimals: 18,
    logo: TokenLogos.LSHARE_NEW,
    isNative: false,
    isWhitelisted: true,
    links: {
      ftmscan: 'https://ftmscan.com/address/0x8fF27b58E1d969bEFC9c8aEAE93A6EB7E2250c8f',
      info: 'https://v3.info.lif3.com/#/fantom/tokens/0x8ff27b58e1d969befc9c8aeae93a6eb7e2250c8f',
    },
  },
  // L3USD token
  L3USD: {
    address: '0x5f0456f728e2d59028b4f5b8ad8c604100724c6a',
    symbol: 'L3USD',
    name: 'L3USD',
    decimals: 18,
    logo: TokenLogos.L3USD,
    isNative: false,
    isWhitelisted: true,
    links: {
      ftmscan: 'https://ftmscan.com/token/0x5f0456f728e2d59028b4f5b8ad8c604100724c6a',
      info: 'https://info.lif3.com/token/0xdea12c8c23994ea2d88ed99ee1bdc0ff56f7f9d1?chainId=250',
    },
  },
  // Old LIF3 token
  LIF3_OLD: {
    address: '0xbf60e7414EF09026733c1E7de72E7393888C64DA',
    symbol: 'LIF3',
    name: 'Lif3 (Old)',
    decimals: 18,
    logo: TokenLogos.LIF3_OLD,
    isNative: false,
    isWhitelisted: true,
    links: {
      ftmscan: 'https://ftmscan.com/token/0xbf60e7414EF09026733c1E7de72E7393888C64DA',
      info: 'https://info.lif3.com/token/0xbf60e7414ef09026733c1e7de72e7393888c64da?chainId=250',
    },
  },
  // Old LSHARE token
  LSHARE_OLD: {
    address: '0xCbE0CA46399Af916784cADF5bCC3aED2052D6C45',
    symbol: 'LSHARE',
    name: 'LSHARE (Old)',
    decimals: 18,
    logo: TokenLogos.LSHARE_OLD,
    isNative: false,
    isWhitelisted: true,
    links: {
      ftmscan: 'https://ftmscan.com/token/0xCbE0CA46399Af916784cADF5bCC3aED2052D6C45',
      info: 'https://info.lif3.com/token/0xcbe0ca46399af916784cadf5bcc3aed2052d6c45?chainId=250',
    },
  },
  // axlUSDC token
  AXLUSDC: {
    address: '0x1B6382DBDEa11d97f24495C9A90b7c88469134a4',
    symbol: 'axlUSDC',
    name: 'Axelar USDC',
    decimals: 6,
    logo: TokenLogos.AXLUSDC,
    isNative: false,
    isWhitelisted: true,
  },
  // TOMB token
  TOMB: {
    address: '0x6c021Ae822BEa943b2E66552bDe1D2696a53fbB7',
    symbol: 'TOMB',
    name: 'Tomb',
    decimals: 18,
    logo: TokenLogos.TOMB,
    isNative: false,
    isWhitelisted: true,
  },
  // TSHARE token
  TSHARE: {
    address: '0x4cdF39285D7Ca8eB3f090fDA0C069ba5F4145B37',
    symbol: 'TSHARE',
    name: 'TSHARE',
    decimals: 18,
    logo: TokenLogos.TSHARE,
    isNative: false,
    isWhitelisted: true,
  },
};

// Get whitelisted tokens as array
export const WHITELISTED_TOKENS = Object.values(TOKENS).filter(token => token.isWhitelisted);

// Get token by address
export const getTokenByAddress = (address) => {
  if (!address) return null;
  const normalizedAddress = address.toLowerCase();
  return Object.values(TOKENS).find(token => 
    token.address.toLowerCase() === normalizedAddress
  );
};

// Get token by symbol
export const getTokenBySymbol = (symbol) => {
  if (!symbol) return null;
  return Object.values(TOKENS).find(token => 
    token.symbol.toLowerCase() === symbol.toLowerCase()
  );
};

// Default slippage settings
export const SLIPPAGE_OPTIONS = [
  { label: '0.1%', value: 0.1 },
  { label: '0.5%', value: 0.5 },
  { label: '1%', value: 1 },
  { label: '2%', value: 2 },
  { label: '5%', value: 5 },
];

export const DEFAULT_SLIPPAGE = 1;

// V3 fee tiers (in basis points)
export const V3_FEE_TIERS = {
  LOWEST: 100,    // 0.01%
  LOW: 500,       // 0.05%
  MEDIUM: 3000,   // 0.3%
  HIGH: 10000,    // 1%
};

// Get all V3 fee tiers as array
export const V3_FEE_TIERS_ARRAY = Object.values(V3_FEE_TIERS);

// Custom token storage key
export const CUSTOM_TOKENS_STORAGE_KEY = 'chadswap_v2_custom_tokens';

// Get custom tokens from localStorage
export const getCustomTokens = () => {
  try {
    const stored = localStorage.getItem(CUSTOM_TOKENS_STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error loading custom tokens:', error);
    return [];
  }
};

// Save custom tokens to localStorage
export const saveCustomTokens = (tokens) => {
  try {
    localStorage.setItem(CUSTOM_TOKENS_STORAGE_KEY, JSON.stringify(tokens));
  } catch (error) {
    console.error('Error saving custom tokens:', error);
  }
};

// Add custom token
export const addCustomToken = (tokenData) => {
  const customTokens = getCustomTokens();
  const exists = customTokens.find(t => 
    t.address.toLowerCase() === tokenData.address.toLowerCase()
  );
  
  if (!exists) {
    customTokens.push({
      ...tokenData,
      isCustom: true,
      isWhitelisted: false,
    });
    saveCustomTokens(customTokens);
  }
  
  return customTokens;
};

// Remove custom token
export const removeCustomToken = (address) => {
  const customTokens = getCustomTokens();
  const filtered = customTokens.filter(t => 
    t.address.toLowerCase() !== address.toLowerCase()
  );
  saveCustomTokens(filtered);
  return filtered;
};

// Get all tokens (whitelisted + custom)
export const getAllTokens = () => {
  return [...WHITELISTED_TOKENS, ...getCustomTokens()];
};
